import type { TranslationKey } from "@/locales/i18n";

export const TICKET_LIST_VIEW_KEYS = ["all", "assigned", "unassigned", "participating", "uncategorized", "recently-resolved"] as const;

export type TicketListViewKey = (typeof TICKET_LIST_VIEW_KEYS)[number];

export type TicketListViewDefinition = {
  key: TicketListViewKey;
  labelKey: TranslationKey;
  titleKey: TranslationKey;
  descriptionKey: TranslationKey;
  path: string;
};

export const TICKET_LIST_VIEW_DEFINITIONS: Record<TicketListViewKey, TicketListViewDefinition> = {
  all: {
    key: "all",
    labelKey: "ticketView.all.label",
    titleKey: "ticketView.all.title",
    descriptionKey: "ticketView.all.description",
    path: "/tickets/all",
  },
  assigned: {
    key: "assigned",
    labelKey: "ticketView.assigned.label",
    titleKey: "ticketView.assigned.title",
    descriptionKey: "ticketView.assigned.description",
    path: "/tickets/assigned",
  },
  unassigned: {
    key: "unassigned",
    labelKey: "ticketView.unassigned.label",
    titleKey: "ticketView.unassigned.title",
    descriptionKey: "ticketView.unassigned.description",
    path: "/tickets/unassigned",
  },
  participating: {
    key: "participating",
    labelKey: "ticketView.participating.label",
    titleKey: "ticketView.participating.title",
    descriptionKey: "ticketView.participating.description",
    path: "/tickets/participating",
  },
  uncategorized: {
    key: "uncategorized",
    labelKey: "ticketView.uncategorized.label",
    titleKey: "ticketView.uncategorized.title",
    descriptionKey: "ticketView.uncategorized.description",
    path: "/tickets/uncategorized",
  },
  "recently-resolved": {
    key: "recently-resolved",
    labelKey: "ticketView.recentlyResolved.label",
    titleKey: "ticketView.recentlyResolved.title",
    descriptionKey: "ticketView.recentlyResolved.description",
    path: "/tickets/recently-resolved",
  },
};

export function ticketListViewPath(view: TicketListViewKey): string {
  return TICKET_LIST_VIEW_DEFINITIONS[view].path;
}
